import { Component, OnInit, ViewChild, AfterContentChecked } from '@angular/core';
import { Cotizacion, TipoCotizacion, EstadoCotizacion } from '../../../../interfaces/cotizacion';
import { ListarItemsComponent } from '../../../../forms/cotizaciones/items/listar-items/listar-items.component';
import { MatSnackBar, MatTabGroup, MatTabChangeEvent } from '@angular/material';
import { CotizacionService } from '../../../../providers/cotizacion.service';
import { ActivatedRoute } from '@angular/router';
import { Entidad, TipoEntidad } from '../../../../interfaces/entidad';
import { Item } from '../../../../interfaces/item';
import { VerIncidenciasComponent } from '../../../../forms/incidencias/ver-incidencias/ver-incidencias.component';
import { Producto } from '../../../../interfaces/producto';
import { Accesorio } from '../../../../interfaces/accesorio';
import { DetalleService, DetalleNombre } from '../../../../providers/detalle.service';
import { TipoGarantia } from '../../../../interfaces/tipo-garantia';
import { VerArchivosCotizacionComponent } from '../../../../forms/cotizaciones/archivos-cotizacion/ver-archivos-cotizacion/ver-archivos-cotizacion.component';
import { TipoMoneda } from '../../../../interfaces/tipo-moneda';
import { TipoPago } from '../../../../interfaces/tipo-pago';
import { TipoValidez } from '../../../../interfaces/tipo-validez';
import { TipoPlazo } from '../../../../interfaces/tipo-plazo';
import { TipoProducto } from '../../../../interfaces/tipo-producto';
import { TipoEntrega } from '../../../../interfaces/tipo-entrega';
import { Competidor } from '../../../../interfaces/competidor';
import { Usuario } from '../../../../interfaces/usuario';
import { VerTareasComponent } from '../../../../forms/tareas/ver-tareas/ver-tareas.component';

@Component({
  selector: 'app-detalle-cotizacion-pagina',
  templateUrl: './detalle-cotizacion-pagina.component.html',
  styleUrls: ['./detalle-cotizacion-pagina.component.scss']
})
export class DetalleCotizacionPaginaComponent implements OnInit, AfterContentChecked {
  cargando: boolean = true;
  IdCotizacion?: number | string;
  cotizacion: Cotizacion;
  tabSelectedIndex: number = 0;

  @ViewChild('archivosCotizacion') archivosCotizacion: VerArchivosCotizacionComponent;
  @ViewChild('verIncidencias') verIncidencias: VerIncidenciasComponent;
  @ViewChild('verTareas') verTareas: VerTareasComponent;
  @ViewChild(ListarItemsComponent) listadoItems: ListarItemsComponent;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;

  constructor(
    private route: ActivatedRoute,
    private cotizacionService: CotizacionService,
    private snackBar: MatSnackBar,
    private detalleService: DetalleService
  ) { }

  ngOnInit() {
    this.cotizacion = new Cotizacion();

    // crear un cotizacion con el ID buscado
    this.route.params.subscribe(params => {
      this.IdCotizacion = params['id'];
      this.actualizarDetalle();
    });
  }

  ngAfterContentChecked() {
    if (this.tabGroup && this.tabGroup._tabs && this.tabGroup._tabs.length > 1) {
      this.tabSelectedIndex = this.detalleService.getDetalleTabActivo(DetalleNombre.DETALLE_COTIZACION);
    }
  }

  // get active tab on change
  selectedTabChange(event: MatTabChangeEvent): void {
    var tabActivo = +event.index;
    this.detalleService.setDetalleTabActivo(DetalleNombre.DETALLE_COTIZACION, tabActivo);
  }

  actualizarArchivos(): void { // actualizar cotizaciones del prospecto
    this.archivosCotizacion.IdCotizacion = this.IdCotizacion;
    this.archivosCotizacion.actualizarTabla();
  }

  actualizarIncidencias(): void { // actualizar incidencias del prospecto
    this.verIncidencias.actualizarTabla();
  }

  actualizarTareas(): void { // actualizar incidencias del prospecto
    this.verTareas.actualizarTabla();
  }

  actualizarDetalle(): void { // traer datos del cotizacion para mostrarlos    
    this.cargando = true;
    this.cotizacionService.getCotizaciones(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'fechaAlta',
        order: 'asc'
      },
      {
        IdCotizacion: this.IdCotizacion,
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data) {
          var cotizacion = respuesta.data.cotizaciones[0];
          if (cotizacion) {
            respuesta.data.cotizaciones.forEach(cotizacion => {
              this.cotizacion = new Cotizacion(
                cotizacion.IdCotizacion,
                cotizacion.fechaAlta,
                <Entidad>{
                  IdEntidad: cotizacion.entidad.id,
                  razonSocial: cotizacion.entidad.razonSocial,
                  tipoEntidad: <TipoEntidad>{
                    IdTipo: cotizacion.entidad.tipo.IdTipo,
                    descripcion: cotizacion.entidad.tipo.TipoDescripcion
                  }
                },
                <TipoCotizacion>{
                  IdTipo: cotizacion.tipo.id,
                  descripcion: cotizacion.tipo.descripcion
                },
                cotizacion.detalle,
                <Item[]>[],
                new TipoEntrega(
                  cotizacion.tipoEntrega.id,
                  cotizacion.tipoEntrega.descripcion
                ),
                <EstadoCotizacion>{
                  IdEstado: cotizacion.estado.id,
                  descripcion: cotizacion.estado.descripcion
                },
                cotizacion.total,
                <TipoGarantia>{
                  id: cotizacion.garantia.id,
                  descripcion: cotizacion.garantia.descripcion
                },
                Object.assign([], cotizacion.condiciones),
                cotizacion.obra,
                cotizacion.fechaVencimiento,
                cotizacion.horaVencimiento ? cotizacion.horaVencimiento : null,
                cotizacion.estadoMotivo,
                cotizacion.destinoEntrega,
                new TipoMoneda(
                  cotizacion.moneda.id,
                  cotizacion.moneda.descripcion,
                  cotizacion.moneda.subfijo
                ),
                new TipoPago(
                  cotizacion.pago.id,
                  cotizacion.pago.descripcion
                ),
                new TipoValidez(
                  cotizacion.validez.id,
                  cotizacion.validez.descripcion
                ),
                Object.assign([], cotizacion.tipoImpuesto),
                cotizacion.fechaApertura,
                !!+cotizacion.editable,
                cotizacion.created_by,
                cotizacion.numero,
                cotizacion.fechaHoraModificacion,
                new Competidor(
                  cotizacion.competidor.id,
                  cotizacion.competidor.descripcion
                ),
                cotizacion.vecesModificada,
                new Usuario(
                  cotizacion.responsable.IdUsuario,
                  cotizacion.responsable.usuario,
                  null,
                  null,
                  null,
                  cotizacion.responsable.nombre,
                  cotizacion.responsable.apellido
                ),
                !!+cotizacion.alMenosUnArchivo,
                cotizacion.observaciones_venta,
                cotizacion.motivo_venta_rechazada,
              );
            });

            this.traerItems(+this.cotizacion.IdCotizacion); // traer sus items
            setTimeout(() => {
              this.actualizarArchivos();
            }, 10);
          } else {
            this.snackBar.open('No se encontraron los datos buscados', 'OK', { duration: 2750 });
          }
        }
      },
      () => {
        this.cargando = false;
      },
      () => {
        this.cargando = false;
      }
    );
  }

  traerItems(IdCotizacion: number): void {
    if (IdCotizacion) { // si hay un ID
      this.cotizacion.items = [];
      this.listadoItems.setCargando(true);
      this.cotizacionService.getCotizacionItems(
        {
          page: null,
          pageSize: null
        },
        {
          sort: 'fechaAlta',
          order: 'asc'
        },
        {
          IdCotizacion: IdCotizacion
        }
      ).subscribe(
        respuesta => {
          if (respuesta.estado == 1 && respuesta.data && respuesta.data.items) {
            respuesta.data.items.forEach(item => {
              this.cotizacion.items.push(
                new Item(
                  item.IdItem,
                  <Producto>{
                    IdProducto: item.producto.id,
                    descripcion: item.producto.descripcion,
                    caracteristicas: item.producto.caracteristicas,
                    tipo: <TipoProducto>{
                      descripcion: item.producto.tipo.descripcion
                    }
                  },
                  item.cantidad,
                  item.precioUnitario,
                  item.label,
                  item.customDescripcion,
                  <Accesorio[]>[],
                  !!+item.especial,
                  !!+item.productoPrecioIncluido,
                  new TipoPlazo(
                    item.plazo.id,
                    item.plazo.descripcion
                  )
                )
              );

              var indexLastItem = this.cotizacion.items.length - 1;
              item.accesorios.forEach(accesorio => {
                this.cotizacion.items[indexLastItem].accesorios.push(<Accesorio>{
                  IdAccesorio: accesorio.id,
                  descripcion: accesorio.descripcion,
                  importeAsignado: accesorio.importeAsignado,
                  precioIncluido: !!+accesorio.precioIncluido,
                  cantidad: accesorio.cantidad
                });
              });
            });

            this.listadoItems.setItems(this.cotizacion.items);
          }

          this.listadoItems.setCargando(false);
        },
        () => {
          this.listadoItems.setCargando(false);
        }
      );
    }
  }
}
